import React from 'react';
import * as FaIcons from 'react-icons/fa';

export type IconName = keyof typeof FaIcons;

interface IconProps {
  name: IconName;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({ name, className, style, onClick }) => {
  const IconComponent = FaIcons[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  // Use a type assertion to bypass the TypeScript error
  const IconElement = IconComponent as React.ComponentType<React.SVGProps<SVGSVGElement>>;
  
  return (
    <span className={className} style={style} onClick={onClick}>
      <IconElement aria-hidden="true" />
    </span>
  );
};

export default Icon;
